import Phaser from 'phaser';

/** 金币：击杀掉落 / 宝箱散出，拾取后加分 */
export default class Coin extends Phaser.Physics.Arcade.Sprite {
  value = 5;
  collected = false;

  constructor(scene: Phaser.Scene, x: number, y: number, value = 5) {
    super(scene, x, y, 'coin_0');
    this.value = value;
    scene.add.existing(this);
    scene.physics.add.existing(this);

    this.body?.setSize(10, 10);
    this.setImmovable(true);
    (this.body as Phaser.Physics.Arcade.Body).allowGravity = false;
    this.setDrag(260, 260);

    // 出场时向随机方向弹开一点
    const a = Math.random() * Math.PI * 2;
    const sp = 40 + Math.random() * 60;
    (this.body as Phaser.Physics.Arcade.Body).setVelocity(Math.cos(a) * sp, Math.sin(a) * sp);

    if (scene.anims.exists('coin-spin')) this.anims.play('coin-spin', true);
  }

  collect() {
    if (this.collected) return;
    this.collected = true;
    // 立即禁用身体，避免被重复拾取（磁力/重叠）
    const body = this.body as Phaser.Physics.Arcade.Body;
    if (body) { body.stop(); body.enable = false; }
    this.scene.tweens.add({
      targets: this,
      y: this.y - 14,
      alpha: 0,
      scale: 1.6,
      duration: 260,
      onComplete: () => this.destroy(),
    });
  }
}
